import { useEffect} from 'react';
import {connect} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';
import FormPaso1Screen from './FormPaso1Screen';
import FormPaso2Screen from './FormPaso2Screen';
import FormPaso3Screen from './FormPaso3Screen';
import FormPaso4Screen from './FormPaso4Screen';
import { Wizard } from '../../../components/index';
import ContactosAction from '../../../store/actions/contactos';
import { Box, useTheme } from '@mui/material';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import RuleIcon from '@mui/icons-material/Rule';
import TaskAltIcon from '@mui/icons-material/TaskAlt';

const ContactoNuevoNUBIScreen = ({
    iniciarContacto,
    iniciarContrato
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const navigate = useNavigate();
    const location = useLocation()
    const { item, tipo } = (location && location.state) || { };
    const options = [
        {
            title: 'Contacto',
            subtitle: 'Datos del cliente',
            icon: <AccountBoxIcon sx={{fontSize: 35}} />
        },
        {
            title: 'Documentación y Servicio',
            subtitle: 'Imagenes y Planes',
            icon: <DescriptionOutlinedIcon sx={{fontSize: 35}} />
        },
        {
            title: 'Servicio Adicionales',
            subtitle: '',
            icon: <RuleIcon sx={{fontSize: 35}} />
        },{
            title: 'Finalizar Pre-Venta',
            subtitle: '',
            icon: <TaskAltIcon sx={{fontSize: 35}} />
        }
    ];

    useEffect(() => {
        if(item){
            iniciarContacto(item);
            if(item.contrato){
                iniciarContrato(item.contrato);
            }
        }
        document.title = 'Nueva Venta';
        navigate('/contactos/nuevonubi#step1');
        return () => {
            iniciarContacto(null);
            iniciarContrato(null);
        }
    }, []);

    return (
        <Box sx={{width:'100%', height: '100%', overflow:'auto', maxWidth: '1280px', margin: 'auto', backgroundColor: isDarkMode ? '#1F2A40' : '#fff'}} className='side'>
            <Box sx={{p: {xs: 1, sm: 1.5, md: 2}, mb: 0}}>
                <Wizard options={options}>
                    <FormPaso1Screen item={item} tipo={tipo} />
                    <FormPaso2Screen />
                    <FormPaso3Screen />
                    <FormPaso4Screen />
                </Wizard>
            </Box>
        </Box>
    );
};

const mapStateToProps = (state) => ({
    contacto: state.contactos.current,
});

const mapDispatchToProps = (dispatch) => ({
    iniciarContacto: (data) => dispatch(ContactosAction.iniciarContacto(data)),
    iniciarContrato: (data) => dispatch(ContactosAction.iniciarContrato(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactoNuevoNUBIScreen);
